import React, { useState, useEffect, useContext } from "react";

const UIToolsContext = React.createContext();

function UIToolsProvider({ children }) {
  const [windowScroll, setWindowScroll] = useState(0);
  const [viewportWidth, setViewportWidth] = useState(0);
  const [mobileNavbarOpen, setMobileNavbarOpen] = useState(false);
  const [videoOpen, setVideoOpen] = useState(false);

  // Update windowScroll state on scroll
  useEffect(() => {
    const handleScroll = () => {
      setWindowScroll(window.scrollY);
    };

    // Add event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Update viewportWidth state on resize
  useEffect(() => {
    const handleResize = () => {
      setViewportWidth(window.innerWidth);
    };

    // Initialize the viewport width
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Prevent interaction when MobileNavbar is open
  useEffect(() => {
    document.body.style.overflow = mobileNavbarOpen ? "hidden" : "visible";
  }, [mobileNavbarOpen]);

  const value = {
    windowScroll,
    viewportWidth,
    mobileNavbarOpen,
    setMobileNavbarOpen,
    videoOpen,
    setVideoOpen,
  };

  return (
    <UIToolsContext.Provider value={value}>
      {children}
    </UIToolsContext.Provider>
  );
}

export default UIToolsProvider;

export function useUIToolsContext() {
  const context = useContext(UIToolsContext);

  // Return default values if context is not available
  if (!context) {
    return {
      windowScroll: 0,
      viewportWidth: 0,
      mobileNavbarOpen: false,
      setMobileNavbarOpen: () => {},
      videoOpen: false,
      setVideoOpen: () => {},
    };
  }

  return context;
}
